import React from 'react';
import useTheme from '../hooks/useTheme';

interface IconWrapProps {
  icon: React.ReactNode;
  size?: number;
  color?: 'default' | 'primary' | 'secondary' | 'accent' | 'highlight' | 'feature' | 'muted';
  style?: React.CSSProperties;
  withBackground?: boolean;
}

export const IconWrap: React.FC<IconWrapProps> = ({
  icon,
  size = 18,
  color = 'muted',
  style = {},
  withBackground = false,
}) => {
  const { theme } = useTheme();

  const colorMap = {
    default: theme.text.primary,
    primary: theme.colors.primary,
    secondary: theme.colors.secondary,
    accent: theme.colors.accent,
    highlight: theme.colors.highlight,
    feature: theme.colors.feature,
    muted: theme.text.muted,
  };

  const iconColor = colorMap[color];
  const bgColor = withBackground ? `${iconColor}15` : 'transparent';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: `${size}px`,
        color: iconColor,
        backgroundColor: bgColor,
        borderRadius: withBackground ? '50%' : '0',
        padding: withBackground ? '8px' : '0',
        width: withBackground ? `${size + 16}px` : 'auto',
        height: withBackground ? `${size + 16}px` : 'auto',
        ...style,
      }}
    >
      {icon}
    </span>
  );
};

